var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3069_9306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.57153 8.28577C8.57153 6.07663 10.3624 4.28577 12.5715 4.28577H30.8573L39.4287 12.8572V39.7143C39.4287 41.9235 37.6378 43.7143 35.4287 43.7143H12.5715C10.3624 43.7143 8.57153 41.9235 8.57153 39.7143V8.28577Z",
    fill: "url(#paint0_linear_3069_9306)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8573 12.8572L39.4287 12.8572L30.8573 4.28575L30.8573 10.8572C30.8573 11.9617 31.7527 12.8572 32.8573 12.8572Z",
    fill: "#52A0FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M19.7419 31.7143L16.4556 20.9143H18.8316L20.5904 26.9469C20.6624 27.1629 20.7241 27.3994 20.7756 27.6566C20.8373 27.9034 20.8836 28.1452 20.9144 28.3817C20.9556 28.608 20.9864 28.824 21.007 29.0297C21.0379 29.2252 21.0636 29.3897 21.0841 29.5234L20.7139 29.508C20.8064 29.076 20.8836 28.716 20.9453 28.428C21.007 28.1297 21.0636 27.8674 21.115 27.6412C21.1767 27.4046 21.2487 27.168 21.331 26.9314L23.0281 22.4726H24.9413L26.6076 26.9314C26.731 27.24 26.8287 27.5383 26.9007 27.8263C26.983 28.104 27.0499 28.3766 27.1013 28.644C27.1527 28.9012 27.2041 29.1634 27.2556 29.4309L26.9161 29.4926C26.947 29.2766 26.9676 29.0914 26.9779 28.9372C26.9984 28.7726 27.0139 28.6234 27.0241 28.4897C27.0447 28.356 27.0653 28.2223 27.0859 28.0886C27.1064 27.9446 27.1373 27.78 27.1784 27.5949C27.2196 27.3994 27.2813 27.1732 27.3636 26.916L29.107 20.9143H31.4521L28.135 31.7143H26.4224L23.7533 25.3269L24.0001 25.3577L21.5161 31.7143H19.7419Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3069_9306",
    x1: 24.0001,
    y1: 43.7143,
    x2: 24.0001,
    y2: 4.28577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006AF5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3069_9306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/doc-icon.db9f86f6ad4144c98bbbf1b82765961c.svg";
export { ForwardRef as ReactComponent };